import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'

const FlatDealsPage = () =>
  import('@/apps/adok/pages/flat-deals').then((m) => m.FlatDealsPage)

const flatDealsRoutes: RouteRecordRaw[] = [
  {
    path: '/advertising/deals',
    component: Layout,
    children: [
      {
        path: '',
        name: 'deals',
        component: FlatDealsPage,
        meta: {
          title: 'Deals'
        }
      },
      {
        path: 'new',
        name: 'deals-new',
        component: FlatDealsPage,
        meta: {
          title: 'Create Flat Deal',
          hidden: true
        }
      },
      {
        path: 'new/own',
        name: 'deals-new-own',
        component: FlatDealsPage,
        meta: {
          title: 'Create Flat Deal',
          hidden: true
        }
      },
      {
        // No caller in the app any more — the spots page opens that modal over its own
        // list — and kept only so URLs already out there still land.
        path: 'new/spot/:spotId',
        name: 'deals-new-from-spot',
        component: FlatDealsPage,
        meta: {
          title: 'Create Flat Deal',
          hidden: true
        }
      },
      {
        path: ':dealId/edit',
        name: 'deals-edit',
        component: FlatDealsPage,
        meta: {
          title: 'Edit Flat Deal',
          hidden: true
        }
      },
      {
        path: ':dealId/clone',
        name: 'deals-clone',
        component: FlatDealsPage,
        meta: {
          title: 'Clone Flat Deal',
          hidden: true
        }
      }
    ]
  }
]

export default flatDealsRoutes
